<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="会員情報の更新"
        width="40"
        class="mb30"
      /><br />{{ $t("verifyPhoneCode") }}
    </h2>
    <div class="account-box">
      <p class="txt-phone">
        <span v-if="!$v.verificationCode.required">{{
          $t("verificationCode")
        }}</span>
        <input
          maxlength="6"
          type="text"
          v-model="verificationCode"
          id="verificationCode"
          name="verificationCode"
        />
      </p>
    </div>
    <p class="txt-error center mb40" v-if="phoneError">
      {{ $t("phoneAlreadyExist") }}
    </p>
    <p class="txt-error center mb40" v-if="vaError">
      {{ $t("validationError") }}
    </p>
    <p class="txt-error center mb40" v-if="codeError">
      {{ $t("errorValidationPhone") }}
    </p>
    <p class="txt-error center mb40" v-if="errorServer">
      {{ $t("errorServer") }}
    </p>
    <p class="btn-normal">
      <button @click="validateCode" id="phoneButton">
        {{ $t("validateCode") }}
      </button>
    </p>
    <div class="center">
      <button class="nostyle" id="resendButton">
        {{ $t("resendCode") }}
      </button>
    </div>
    <br />
    <br />
    <p class="center mt00 mb00">{{ $t("failSendCode1") }}</p>
    <p class="phoneValidateText mt00" @click="goBack">
      {{ $t("failSendCode2") }}
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import parser from "ua-parser-js";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AccountValidatePhoneCode",
  data() {
    return {
      phoneError: false,
      verificationId: "",
      verificationCode: "",
      phone: "",
      oldPhone: "",
      countryCode: "",
      userData: "",
      vaError: false,
      newRegistration: false,
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      codeError: false,
      errorServer: false,
    };
  },
  validations: {
    verificationCode: {
      required,
    },
  },
  mounted() {
    try {
      firebase.auth().useDeviceLanguage();
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "resendButton",
        {
          size: "invisible",
          callback: async () => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            await this.resendCode();
          },
          "expired-callback": () => {
            window.recaptchaVerifier.reset();
          },
        }
      );
      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      });
    } catch (e) {
      //console.log(e);
    }
  },
  created() {
    this.verificationId = this.$route.params.verificationId;
    this.phone = this.$route.params.phone;
    this.countryCode = this.$route.params.countryCode;
    this.newRegistration = this.$route.params.newRegistration;
  },
  watch: {
    verificationCode() {
      this.codeError = false;
      this.phoneError = false;
    },
  },
  methods: {
    async resendCode() {
      const appVerifier = window.recaptchaVerifier;
      let provider = new firebase.auth.PhoneAuthProvider();
      try {
        this.verificationId = await provider.verifyPhoneNumber(
          this.countryCode + this.phone,
          appVerifier
        );
        this.$toasted.success(this.$t("codeResent"));
        window.recaptchaVerifier.reset();
      } catch (error) {
        //SMS Could not be sent
        window.recaptchaVerifier.reset();
        this.errorServer = true;
      }
    },
    goBack() {
      //this.$router.go(-1);
      /* this.$router.push({
        name: "AccountEditPhone",
      }); */
      if (this.newRegistration) {
        this.$router.push({ name: "AccountRegisterPhone" });
      } else {
        this.$router.push({ name: "AccountEditPhone" });
      }
    },
    async validateCode() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.vaError = true;
      } else {
        try {
          let phoneCredential = firebase.auth.PhoneAuthProvider.credential(
            this.verificationId,
            this.verificationCode
          );
          // update firebase auth
          await firebase.auth().currentUser.updatePhoneNumber(phoneCredential);
          // update firebase db
          await this.writeDB();
          if (this.newRegistration) {
            this.$router.push({ name: "AccountProfileCreateCompleted" });
          } else {
            this.$router.push({ name: "AccountValidatePhoneCompleted" });
          }
        } catch (error) {
          if (error.code == "auth/credential-already-in-use") {
            this.phoneError = true;
          } else {
            // verification code wrong
            this.codeError = true;
          }
        }
      }
    },
    async writeDB() {
      let useragent = parser(navigator.userAgent);
      await this.db
        .collection("users")
        .doc(this.user.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            this.userData = data;
          }
        });
      let logData = {
        uid: this.user.uid,
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        from_phone: this.userData.phone == undefined ? "" : this.userData.phone,
        to_phone: this.phone,
        phone: this.phone,
      };
      if (this.userData.userAgentOS !== useragent.os.name) {
        logData.from_userAgentOS =
          this.userData.userAgentOS == undefined
            ? ""
            : this.userData.userAgentOS;
        logData.to_userAgentOS = useragent.os.name;
      }
      const updateLogRef = this.db.collection("usersUpdatesLog").doc();
      await updateLogRef.set(logData);

      let docData = {
        phone: this.phone,
        phone_country_code: this.countryCode,
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        userAgentOS: useragent.os.name,
      };
      if (this.newRegistration) {
        docData.status = "1";
      }
      await this.db
        .collection("users")
        .doc(this.user.uid)
        .update(docData)
        .catch((error) => {
          this.errorCode = error.code;
          this.fbError = true;
          return;
        });
    },
  },
};
</script>
